import type { SessionManagerState } from './_state.type';

/** SessionManager State. */
export const sessionManagerState: SessionManagerState = {
  sessionManager: {
    isSync: false,
    sessions: [],

    open: false,
  },
};
